module.exports = __webpack_public_path__ + "static/media/xano-auth-logo.5f79d5b9.png";